import "./myProfileHeader.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { icons, profileImages } from "../../utils/globalImages";
import AvatarUploadModal from "../AvatarUpload/AvatarUploadModal";
import ArrowProgressBar from "../common/ProgressBar/ArrowProgressBar";
import { formatDate } from "../../utils/HelperFunctions";

function MyProfileHeader() {
  const user = useSelector((state) => state?.auth?.user);
  const userAccount = useSelector((state) => state?.account);
  const [openAvatarDialog, setOpenAvatarDialog] = useState(false);

  return (
    <>
      <div
        className="container-fluid bg-eerie-black border-radius-16px"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundImage: `url(${profileImages?.bgBoxes})`,
        }}
      >
        <div className="row p-16px">
          <div className="col-sm-6 col-md-3 col-12 d-start">
            <div className="avatar-container">
              <img
                width={74.953}
                height={74.953}
                alt="User Avatar"
                src={user?.userdetails?.avatar}
                className="object-fit-cover border-radius-16px"
              />

              <div
                onClick={() => setOpenAvatarDialog(true)}
                className="d-center avatar-edit-btn cursor-pointer"
              >
                <img
                  alt="edit"
                  className="pencil-icon"
                  src={icons.blackPencilIcon}
                />
              </div>
            </div>

            <div className="ms-4 d-start flex-column">
              <div className="w-100 d-flex gap-9px">
                <span className="text-22px text-AktivGrotesk-Bold">{user?.username}</span>
                {user?.kyc && (
                  <img
                    alt="kyc badge"
                    src={icons.kycBadge}
                    className="kyc-icon"
                  />
                )}
              </div>
              <span className="text-14px text-AktivGrotesk-Medium text-fw-400 text-medium-gray">
                Member Since {formatDate(user?.created_at)}
              </span>
            </div>
          </div>

          <div className="col-sm-6 col-md-9 col-12 mt-lg-0 mt-3 p-24px border-radius-16px bg-jet-black">
            <ArrowProgressBar user={userAccount} />
          </div>
        </div>
      </div>

      {/* DIALOG */}
      <AvatarUploadModal
        isDarkMode={true}
        open={openAvatarDialog}
        onClose={() => setOpenAvatarDialog(false)}
        currentAvatar={user?.userdetails?.avatar}
      />
    </>
  );
}

export default MyProfileHeader;
